// import '@/assets/js/jquery.min'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import 'babel-polyfill';
import "./assets/js/global";
import "./assets/js/brandConfig.js";
import "./assets/js/init";
import Vue from "vue";
import "@/assets/js/umengMTA"; // 友盟数据统计
import "./cube-ui";
import vueResource from "vue-resource";
import VueLazyLoad from "vue-lazyload";
import App from "./App";
import router from "./router";
import store from "./store";
import "@/assets/js/comefrom"; // 获取第三方入口参数
import "./assets/css/index.less";
import "@/assets/icons";
// import tracekit from './assets/js/tracekit.js'
import { VueTouch } from "./assets/js/vueTouch";
import VConsole from "vconsole";
import MintUI, { Toast } from "mint-ui";
import "mint-ui/lib/style.css";
import Slider from "./assets/js/Slider";
import { PullRefresh } from "vant";
import { wechatSDK, formatPrice } from "@/assets/js/util";
import wx from "weixin-js-sdk";

import Change from "@/directive/change";
import directives from "@/directive";
import { baiDuMtaEvent } from "@/assets/js/util"; // 百度事件统计
import "@/assets/js/flutterPlugin";
import "@/assets/js/dsfunny";
import customerService from "@/assets/js/customerService";

Vue.use(MintUI);
Vue.use(PullRefresh);

Vue.use(Change);
Vue.use(directives);
Vue.filter("G_formatPrice", formatPrice);
// 全局挂载toast
Vue.use({
  install: function (Vue, options) {
    Vue.prototype.$toast = function (payload) {
      Vue.$toastObj && Vue.$toastObj.close();
      Vue.$toastObj = Toast(payload);
    };
  },
});

function formatComponentName(vm) {
  if (vm.$root === vm) return "root";
  var name = vm._isVue
    ? (vm.$options && vm.$options.name) ||
      (vm.$options && vm.$options._componentTag)
    : vm.name;
  return (
    (name ? "component <" + name + ">" : "anonymous component") +
    (vm._isVue && vm.$options && vm.$options.__file
      ? " at " + (vm.$options && vm.$options.__file)
      : "")
  );
}

Vue.config.errorHandler = function (err, vm, info) {
  var componentName = formatComponentName(vm);
  // tracekit(componentName + ' --- ' + err) // bug收集
};
// 捕捉js异常结束

Vue.use(VueLazyLoad, {
  loading: require("./assets/images/default_hospital_icon.jpg"),
  // preLoad: 1.3,   //预加载的宽高比
  error: require("./assets/images/default_hospital_icon.jpg"), // 图片加载失败时使用的图片源
  attempt: 1, // 尝试加载次数
});

// 解决系统自带底部操作栏影响浏览器窗口高度渲染错误的问题
window.addEventListener("resize", function () {
  document.documentElement.style.height = window.innerHeight + "px";
});
document.documentElement.style.height = window.innerHeight + "px";
Vue.config.productionTip = false;
Vue.config.ignoredElements = ['wx-open-launch-weapp'];
Vue.use(vueResource);
Vue.http.options.emulateJSON = true;
Vue.http.interceptors.push((request, next) => {
  if (sessionStorage.getItem("channel")) {
    // 渠道分析
    request.headers.set("Channel-Code", sessionStorage.getItem("channel")); // 请求headers携带参数
  }
  next(function (response) {
    return response;
  });
});
// fastclick.attach(document.body);

// 加入左滑右滑事件
Vue.directive("swipeleft", {
  // 左滑事件
  bind: function (el, binding) {
    /* eslint-disable no-new */
    new VueTouch(el, binding, "swipeleft");
  },
});
Vue.directive("swiperight", {
  // 右滑事件
  bind: function (el, binding) {
    /* eslint-disable no-new */
    new VueTouch(el, binding, "swiperight");
  },
});

Vue.prototype.global = {
  // city_name: (oldCity && oldCity.city_name) ? oldCity.city_name : '深圳',
  // city_id: (oldCity && oldCity.city_id) ? oldCity.city_id : 200,
  search_type: 1, // 判断搜索是套餐优先还是机构优先 默认1 套餐优先 2 机构优先
  is_first_get_id: true,
};

// 全局挂载slider方法
// 调用方式: this.$slider.slideDown.(document, time);
// 调用方式: this.$slider.slideUp.(document, time);
Vue.prototype.$slider = Slider;

// 全局挂载品牌标识
Vue.prototype.$brandConfig = brandConfig;

Vue.prototype.$customerService = customerService;
Vue.prototype.$baiDuMtaEvent = baiDuMtaEvent;

/* eslint-disable no-new */
const vm = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
// 测试环境开调试
if (location.href.match(/console/)) {
  /* eslint-disable */
  new VConsole();
  /* eslint-disable */
}

if (location.href.indexOf("wechat/h5#/group-buy-detail") !== -1) {
  wechatSDK({
    jsApiList: ["hideMenuItems"],
    success: () => {
      // 隐藏分享到朋友圈
      wx.hideMenuItems({
        menuList: ["menuItem:share:timeline"],
      });
    },
  });
}

if (location.href.indexOf("wechat/h5#/group-buy-detail") !== -1) {
  wechatSDK({
    jsApiList: ["hideMenuItems"],
    success: () => {
      // 隐藏分享到朋友圈
      wx.hideMenuItems({
        menuList: ["menuItem:share:timeline"],
      });
    },
  });
}
export default vm;
